// extracted by mini-css-extract-plugin
module.exports = {"root":"LoaderDots_root__XVQQi","dot":"LoaderDots_dot__KBhAY","blink":"LoaderDots_blink__H26iy","isDark":"LoaderDots_isDark__n81aS"};